import React from "react";
import "./Navbar.css";
import MuteButton from "./Mutebutton";

export default function Navbar({ voiceOn, toggleVoice }) {
  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img src="/drip_logo.png" alt="Logo 1" className="navbar-logo1" />
        <img src="/logo_lmu.png" alt="Logo 2" className="navbar-logo" />
      </div>
      <div className="navbar-right">
        <MuteButton voiceOn={voiceOn} toggleVoice={toggleVoice} />
      </div>
    </nav>
  );
}
